export const PRICE_POINT_LIST = [
	{ id: 'LOW', text: 'LOW', value: 'LOW', label: 'Regular' },
	{ id: 'MID', text: 'MID', value: 'MID', label: 'Mid' },
	{ id: 'HIGH', text: 'HIGH', value: 'HIGH', label: 'Premium' }
];
export const NITEX_RND_LIST = [
	{ id: true, text: 'Yes', value: 'Yes', label: 'Yes' },
	{ id: false, text: 'No', value: 'No', label: 'No' }
];
export const FABRIC_BASE_LIST = [
	{ id: 'PREMIUM', text: 'Premium', value: 'Premium', label: 'Premium' },
	{ id: 'SEASONAL', text: 'Seasonal', value: 'Seasonal', label: 'Seasonal' },
	{ id: 'CORE', text: 'Core', value: 'Core', label: 'Core' },
	{ id: 'REGULAR', text: 'Regular', value: 'Regular', label: 'Regular' }
];

export const PAIR_FABRIC = [
	{ id: 'RIB', text: 'RIB', value: 'Rib', lebel: 'Rib' },
	{ id: 'CUFF', text: 'CUFF', value: 'Cuff', lebel: 'Cuff' },
	{
		id: 'CUFF_AND_BOTTOM_RIB',
		text: 'CUFF_AND_BOTTOM_RIB',
		value: 'Cuff & Bottom Rib',
		lebel: 'Cuff & Bottom Rib'
	},
	{ id: 'COLLAR', text: 'COLLAR', value: 'Collar', lebel: 'Collar' },
	{
		id: 'COLLAR_AND_SLEEVE',
		text: 'COLLAR_AND_SLEEVE',
		value: 'Collar & Sleeve',
		lebel: 'Collar & Sleeve'
	},
	{ id: 'COLLAR_AND_CUFF', text: 'COLLAR_AND_CUFF', value: 'Collar & Cuff', lebel: 'Collar & Cuff' },
	{ id: 'NECK_AND_CUFF', text: 'NECK_AND_CUFF', value: 'Neck & Cuff', lebel: 'Neck & Cuff' }
];

export const PAIR_TRIMS = [
	{ id: 'ZIPPER', text: 'ZIPPER', value: 'Zipper', lebel: 'Zipper' },
	{ id: 'BUTTON', text: 'BUTTON', value: 'Button', lebel: 'Button' },
	{ id: 'DRAWCORD', text: 'DRAWCORD', value: 'Drawcord', lebel: 'Drawcord' },
	{ id: 'BUNGE_CORD', text: 'BUNGE_CORD', value: 'Bunge cord', lebel: 'Bunge cord' },
	{ id: 'TAPE', text: 'TAPE', value: 'Tape', lebel: 'Tape' }
];

export const WEIGHT_TYPES = [
	{
		id: 'GREIGE',
		value: 'GREIGE'
	},
	{
		id: 'RFD',
		value: 'RFD'
	},
	{
		id: 'S/D',
		value: 'S/D'
	},
	{
		id: 'Y/D',
		value: 'Y/D'
	},
	{
		id: 'B/W',
		value: 'B/W'
	},
	{
		id: 'FIBER DYED',
		value: 'FIBER DYED'
	}
];

export const CUTTABLE_WIDTH_TYPES = [
	{
		id: 'CM',
		value: 'CM'
	},
	{
		id: 'INCH',
		value: 'INCH'
	}
];

export const STRIPE_TYPES = [
	{
		id: 'ENGINEERING_STRIPE',
		value: 'Engineering stripe'
	},
	{
		id: 'FEEDER_STRIPE',
		value: 'Feeder stripe'
	}
];

export const PURCHASE_PRICE_TYPES = [
	{
		id: 'USD',
		value: 'USD'
	},
	{
		id: 'FOC',
		value: 'FOC'
	}
];

export const FABRIC_QTY_TYPES = [
	{
		id: 'KG',
		value: 'KG'
	},
	{
		id: 'YARD',
		value: 'YARD'
	},
	{ id: 'METER', value: 'METER' },
	{ id: 'PCS', value: 'PCS' }
];

export const MOQ_UNIT = [
	{
		id: '1',
		value: 'KG',
		text: 'KG',
		lebel: 'KG'
	},
	{
		id: '2',
		value: 'METER',
		text: 'Meter',
		lebel: 'Meter'
	},
	{
		id: '3',
		value: 'YARD',
		text: 'Yard',
		lebel: 'Yard'
	},
	{
		id: '4',
		value: 'PCS',
		text: 'Pcs',
		lebel: 'Pcs'
	}
];
